import { ReactNode } from 'react';

interface SellerMyPageButtonProps {
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

export function SellerMyPageButton({ children, onClick, disabled = false }: SellerMyPageButtonProps) {
  const handleClick = () => {
    if (disabled) {
      alert('아직 구현되지 않은 페이지입니다');
      return;
    }
    onClick?.();
  };

  return (
    <div
      className={`
        w-full py-4 px-6 text-left transition-colors
        ${disabled 
          ? 'opacity-60 cursor-not-allowed' 
          : 'cursor-pointer hover:bg-gray-50'
        }
      `}
      onClick={handleClick}
    >
      <span className={`text-[20px] font-semibold ${disabled ? 'text-gray-500' : 'text-[#222222]'}`}>
        {children}
      </span>
    </div>
  );
}